<template>
  <div class="">
    <el-card  class="el-card-define">
      <!-- <div id="dailyReceivable" class="setting-item cheques-details-bg"  @click="toUrl('收款汇总表')">
                <div class="text">
                    <div class="title">收款汇总表</div>
                </div>
      </div> -->
      <div id="collectionRate" class="setting-item confiscation-statistics-bg"  @click="toInternalUrl('收缴率统计表','collectionRateDetail')">
                <div class="text">
                    <div class="title">收缴率统计表</div>
                </div>
      </div>
      <div id="collectionRate" class="setting-item contributions-daily-settlement-details-bg"  @click="toInternalUrl('欠费统计表','feeReceiveArrears')">
                <div class="text">
                    <div class="title">欠款统计表</div>
                </div>
      </div>
      <div id="collectionRate" class="setting-item advance-cheques-balance-bg"  @click="toInternalUrl('欠费统计表','feeReceivableRoomAndCar')">
                <div class="text">
                    <div class="title">应收统计表</div>
                </div>
      </div>
       <div id="collectionRate" class="setting-item confiscation-statistics-bg"  @click="toInternalUrl('减免统计表','feeReliefDetail')">
                <div class="text">
                    <div class="title">减免统计表</div>
                </div>
      </div>
       <div id="collectionRate" class="setting-item confiscation-statistics-bg"  @click="toInternalUrl('预收统计表','feeAdvanceReceiptDetail')">
                <div class="text">
                    <div class="title">预收统计表</div>
                </div>
      </div>
        <div id="collectionRate" class="setting-item advance-cheques-balance-bg"  @click="toInternalUrl('退费统计表','feeReturnDetail')">
                <div class="text">
                    <div class="title">退费统计表</div>
                </div>
      </div>
      <div id="collectionRate" class="setting-item advance-cheques-balance-bg"  @click="toInternalUrl('开票明细表','invoiceDetail')">
                <div class="text">
                    <div class="title">开票明细表</div>
                </div>
      </div>
      <div id="collectionRate" class="setting-item confiscation-statistics-bg"  @click="toInternalUrl('目标值统计表','collectionRateDetaiTarget')">
                <div class="text">
                    <div class="title">目标值统计表</div>
                </div>
      </div>
      <div id="collectionRate" class="setting-item confiscation-statistics-bg"  @click="toInternalUrl('月度实收报表','monthCollectOutside')">
                <div class="text">
                    <div class="title">月度实收报表</div>
                </div>
      </div>
        <div id="collectionRate" class="setting-item confiscation-statistics-bg"  @click="toInternalUrl('实收明细表','feeReceiptsDetail')">
                <div class="text">
                    <div class="title">实收明细表</div>
                </div>
      </div>
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:
 *@Description:报表管理
 *@author:xubz
 *@Copyright:格众科技
 *@date:
 */
export default {
  data() {
    return {
      loading: false,
      html: ''
    }
  },
  mounted () {
  },
  methods: {
    toUrl() {
			var url =
				'https://bi.aliyuncs.com/token3rd/dashboard/view/pc.htm?pageId=6cd0928a-34a7-4177-a888-f90a376c5e9b&accessToken=f34b968a535c54a3f65a7e43947c7a73'
			window.open(url, '_blank') // 新窗口打开外链接
    },
    toInternalUrl(a,b){
       this.$router.push({ name: b})
    }
  }
}
</script>

<style lang= 'scss'>
  .el-card-define {
  min-height: 729px;
  height: 729px;
}
.el-card-define >>> .el-card__body {
  height: 100%;
}
 .el-card-define .cheques-details-bg {
    background: url('../../../assets/imgs/cheques-details-bg.png') center 22px no-repeat #fdfafa;
}
.el-card-define .confiscation-statistics-bg {
    background: url('../../../assets/imgs/confiscation-statistics-bg.png') center 22px no-repeat #fdfafa;
}
.el-card-define .advance-cheques-balance-bg {
    background: url('../../../assets/imgs/advance-cheques-balance-bg.png') center 22px no-repeat #fdfafa;
}
.el-card-define .contributions-daily-settlement-details-bg {
    background: url('../../../assets/imgs/contributions-daily-settlement-details-bg.png') center 22px no-repeat #fdfafa;
}
.el-card-define .setting-item {
    float: left;
    margin-right: 40px;
    margin-bottom: 40px;
    padding: 10px 15px;
    width: 213px;
    height: 140px;
    border-radius: 4px;
    border: 1px solid #e1e1e1;
    text-align: center;
    cursor: pointer;
}
.el-card-define .setting-item:hover {
    border: 1px solid #19d2a0;
}
.el-card-define .setting-item {
    margin-right: 20px;
    margin-bottom: 20px;
}
.el-card-define .setting-item .text {
    margin-top: 80px;
}
</style>
